import React from "react";
import {Link} from "react-router-dom";
import {ListItem} from "@deere/ux.uxframe-react";
import {Box, Grid, Typography} from '@deere/fuel-react';
import {toCapitalize} from "../shared/utils";
import {SendReminderModal} from "../shared/modal/SendReminderModal";
import WarningIcon from "@material-ui/icons/Warning";
import DoneIcon from "@material-ui/icons/Done";

export const Campaign = ({campaign, onSave}) => {
    const status = campaign.status.length > 0 ? toCapitalize(campaign.status) : campaign.status;

    const handleSave = () => {
        onSave(campaign.id)
    }

    return (
        <ListItem className="list-group-item mb-1" style={{borderRadius: "0.25rem"}} key={campaign.id}>
            <Grid container>
                <Grid item xs={12} md={8}>
                    {status === "Published" ? (
                        <Link
                            to={{
                                pathname: `/campaigns/summary/${campaign.id}`,
                            }}>
                            {campaign.title}
                        </Link>
                    ) : (
                        <Link
                            to={{
                                pathname: `/campaigns/edit-campaign/${campaign.id}`,
                            }}>
                            {campaign.title}
                        </Link>
                    )}
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box display="flex" justifyContent="flex-end">
                        <Typography size="md" fontWeight="bold" component="p" display="inline">
                            Status &nbsp;
                        </Typography>
                        {status !== "Published" && (
                            <WarningIcon fontSize="small" style={{fill: "#fab64c", marginRight: "0.25rem"}} display="inline"/>)}
                        {status === "Published" && (
                            <DoneIcon fontSize="small" style={{fill: "#367c2b"}} display="inline"/>)}
                        <Typography size="md" fontWeight="regular" component="p" display="inline">
                            {status}
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography fontWeight="bold" component="p" display="inline">
                        Responses {" "}
                    </Typography>
                    <Typography variant="label" component="p" display="inline">
                        {campaign.responses} {" "}
                    </Typography>
                    <Typography size="sm" component="span" color="tertiary">
                        &nbsp; due {campaign.dueDate}
                    </Typography>

                </Grid>
                <Grid item xs={12} md={3}>
                    {status === "Published" && campaign.reminders.length > 0 && (
                        <SendReminderModal campaignId={campaign.id} onSave={handleSave}/>
                    )}
                </Grid>
                <Grid item xs={12} md={5}>
                    <Box display="flex" justifyContent="flex-end">
                        <Typography size="md" fontWeight="bold" component="p" display="inline">
                            Created By &nbsp;
                        </Typography>
                        <Typography size="md" fontWeight="regular" component="p" display="inline">
                            {campaign.createdBy}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </ListItem>
    );
}
